import type { IconSvgObject } from './types';

const ImageFlipVerticalIcon: IconSvgObject = [
  ["path", { d: "M19 10.5L5 2V10.5H19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 13.5L5 22V13.5H19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ImageFlipVerticalIcon;
